/**
 * Activity 4B: Sea Surface Tracing
 */
export default [
    {
        path: '/sst/',
        name: 'state_4b',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/4b_sst/Sst_4b_Index.vue')
    },
    {
        path: '/sst/video/',
        name: 'state_4b_a',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/4b_sst/Sst_4b_a_Video.vue')
    },
    {
        path: '/sst/graph/',
        name: 'state_4b_b',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/4b_sst/Sst_4b_b_Graph.vue')
    },
    {
        path: '/sst/explore/:index/',
        name: 'state_4b_c',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/4b_sst/Sst_4b_c_Explore.vue')
    },
    {
        path: '/sst/slider/',
        name: 'state_4b_d',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/4b_sst/Sst_4b_d_Slider.vue')
    },
    {
        path: '/sst/reflection/',
        name: 'state_4b_e',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "sst" */ '../views/4b_sst/Sst_4b_e_Reflection.vue')
    }
]